<script setup lang="ts">
import { useTopProgress } from '@/shared/lib'

/** Draws `useTopProgress`'s state — render exactly one, in the app root. */
const { visible, progress } = useTopProgress()
</script>

<template>
  <div
    class="top-progress"
    :class="{ 'top-progress--visible': visible }"
    :style="{ transform: `scaleX(${progress / 100})` }"
    aria-hidden="true"
  />
</template>

<style lang="scss" scoped>
.top-progress {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3000;
  width: 100%;
  height: 2px;
  background: var(--el-color-primary);
  transform-origin: left;
  opacity: 0;
  pointer-events: none;
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;
}

.top-progress--visible {
  opacity: 1;
}
</style>
